import { useDispatch, useSelector } from "react-redux";
import { changeLang, getMobilePopup, mobileLangActive } from "../redux/actions";
import { GroupPanel } from "./GroupPanel";
import { AvatarBlock } from "./AvatarBlock";

export const TopPanel = () => {
  const dispatch = useDispatch()
  const isMobile = useSelector(state => state.app.isMobile)
  const name = useSelector(state => state.user.name)
  const image = useSelector(state => state.user.image)
  const mobileLang = useSelector(state => state.app.mobileLang)
  const lang = useSelector(state => state.app.currentLang);
  const langs = useSelector(state => state.app.langs)
  const isGroup = useSelector(state => state.app.group)
  const currentLangName = useSelector(state => state.app.currentLangName)

  if (isMobile) {
    return (
      <>
        <div className="userHead">
          <div className="userHead__lang_wrap">
            <div className={'userHead__lang ' + (mobileLang ? 'active' : '')}
              onClick={() => dispatch(mobileLangActive(mobileLang))} >
              {currentLangName}
              <div className="userHead__lang_list">
                {
                  langs.map((item) => {
                    if (currentLangName === item.name) {
                      return null;
                    }
                    return (<div className="userHead__lang_item"
                      onClick={() => dispatch(changeLang(item.name, item.lang))}
                      key={item.name}><span>{item.name}</span></div>)
                  })
                }
              </div>
            </div>
          </div>
          <div className="userHead__info">
            <AvatarBlock item={{ image: image, name: name }} className="userHead" isGroup={isGroup} />
          </div>
          <div className="userHead__qBtn" onClick={() => dispatch(getMobilePopup())}>
            <span>?</span>
          </div>
        </div>
        {
          isGroup &&
          <div className="userHead__title">
            {lang.games14}
          </div>
        }
        {isGroup && <GroupPanel />}
      </>
    )
  } else {
    return (
      <>
        <div className="userCard">
          <div className="userCard__control">
            <AvatarBlock item={{ image: image, name: name }} className="userCard" isGroup={isGroup} hasName={false} />
            <div className="userCard__lang">
              {currentLangName}
              <div className="userCard__lang_list">
                {
                  langs.map((item) => {
                    if (currentLangName === item.name) {
                      return null;
                    }
                    return (<div className="userCard__lang_item"
                      onClick={() => dispatch(changeLang(item.name, item.lang))}
                      key={item.name}><span>{item.name}</span></div>)
                  })
                }
              </div>
            </div>
          </div>
          <div className="userCard__name">
            {
              name != null && name
            }
          </div>
        </div>
        {
          isGroup &&
          <div className="userCard__title">
            {lang.games14}
          </div>
        }
      </>
    )
  }
}